export default __webpack_public_path__ + "static/media/ph.dd4d442a.png";